export const Authorized: Record<string, string> = {
  YES: "YES",
  NO: "NO"
};
